export class RetencionModel {

    numFacturaFabril: string;
    emisorRetencion: string;
    rucEmisorRetencion: string;
    cliente: string;
    anios: any[];
    meses: any[];
    empresas: any[];
    oficinas: any[];
    reservado: string;
    sustentado: string;
    statusDoc: string;

    constructor(obj: any) {
        this.numFacturaFabril = obj.numFacturaFabril;
        this.emisorRetencion = obj.retencionEmisor;
        this.rucEmisorRetencion = obj.rucEmisor;
        this.cliente = obj.cliente;
        this.anios = obj.anios || [];
        this.meses = obj.meses || [];
        this.empresas = obj.empresas || []; //["1001","1002"] || [];
        this.oficinas = obj.oficinas || [];
        this.reservado = obj.reservado;
        this.sustentado = obj.sustentado;
        this.statusDoc = obj.statusDoc;
    }
}